export enum UnitOfTime {
  Second = "Second",
  Minute = "Minute",
  Hour = "Hour",
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year",
}

export const UnitOfTimeList = () =>
  Object.entries(UnitOfTime).map(([label, value]) => {
    return { label, value };
  });
